module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_brown.2fd9b1eb.png";